<template>
  <div class="global-search-section">
    <b-form-input class="search-input" @focus="openHistory" v-model="query" placeholder="Type your search term here"
      debounce="400" @keydown.enter.prevent.exact="search"></b-form-input>
    <base-button @click="search" class="search-btn" :disabled="!query">Search</base-button>
    <div class="search-history" v-if="showHistory">
      <p class="history-title">
        Recent
        <span class="clear-btn" title="Clear history" @click="clear">Clear <i class="fa fa-times"
            @click="showHistory = false" title="Close"></i></span>
      </p>

      <div v-for="(value, index) in searchHistory.queries" :key="index + query">
        <p class="search-query" @click="searchRecent(value.label)">
          <i class="fas fa-clock"></i> {{ value.label }}
        </p>
      </div>
      <div v-for="customer in searchHistory.customers" :key="customer.customer_id">
        <p class="search-query" @click="goToProfile(customer.customer_id)">
          <i class="fa fa-search"></i>
          <img :src="customer.profile_picture" class="query-img" alt="" />
          {{ customer.name }} ⋄
          {{ customer.job_title }}
        </p>
      </div>
      <div v-for="company in searchHistory.companies" :key="company.company_id">
        <p class="search-query" @click="goToCompanyProfile(company.company_id)">
          <i class="fa fa-search"></i>
          <img :src="company.logo" class="query-img" alt="" />
          {{ company.name }} ⋄
          {{ company.company_type }}
        </p>
      </div>
      <div v-for="(event, index) in searchHistory.events" :key="event.event_id+index">
        <p class="search-query" @click="goEventPage(event)">
          <i class="fa fa-search"></i>
          <img :src="event.banner" class="query-img" alt="" />
          {{ event.name }}
        </p>
      </div>
      <div v-for="(post,index) in searchHistory.posts" :key="post.post_id+index">
        <p class="search-query" @click="goToPost(post)">
          <i class="fas fa-search"></i> {{ post.content.slice(0, 30) }}
        </p>
      </div>
    </div>
    <div class="global-search-results" v-if="Object.values(searchResults).length">
      <div class="people-section" v-if="searchResults.users.length">
        <b-navbar-toggle target="people-results">
          <template #default="{ expanded }">
              <div></div>
              <p class="section-title">MEMBERS ({{searchResults.users.length}})</p>
              <i v-if="expanded" class="fas fa-angle-up"></i>
              <i v-else class="fas fa-angle-down"></i>
            </template>
        </b-navbar-toggle>
        <b-collapse id="people-results" is-nav>
          <div class="people">
            <div class="member-box" v-for="customer in searchResults.users" :key="customer.id">
              <img :src="
                  customer.profile_picture ||
                  require('@/assets/default-user-profile-image.png')
                " alt="" />
              <div class="userInfo">
                <span class="userName" @click="openProfile(customer)">
                  {{ `${customer.user.first_name} ${customer.user.last_name}` }}
                </span>
                <span class="userPosition">{{ customer.job_title }}</span>
                <span class="userCompany" @click="getID(customer.company)">
                  {{ customer.company_name }}
                </span>
              </div>
              <div class="iconsForUserDesc" v-show="customer.id !== userInfo.customer_id">
                  <i class="fas fa-user-friends action-icon" v-b-tooltip.hover title="Request has been sent"
                    v-if="customer.friendship_status.status === 'sent request'" style="cursor: default" />
                  <i class="fas fa-user-friends action-icon" v-b-tooltip.hover title="Member sent Request to you" v-if="
                      customer.friendship_status.status ===
                      'pending request or you'
                    " @click="goToNetwork()" />
                  <i class="fas fa-user-plus action-icon" v-b-tooltip.hover title="Add member" v-if="
                      customer.friendship_status.status === '' &&
                      !isMemberMarkedMeAsSpam(customer) &&
                      !isMarkedAsSpam(customer)
                    " @click="
                      toNetwork(customer),
                        (customer.friendship_status.status = 'friend'),
                        (customer.friendship_status.status = 'sent request')
                    " />
                  <i class="fas fa-user-times action-icon" style="color: gray" v-b-tooltip.hover title="Unfriend Member"
                    v-if="customer.friendship_status.status === 'friend'" @click="
                      deleteNetwork(customer.friendship_status.network_url),
                        (customer.friendship_status.status = '')
                    " />
                  <i class="fas fa-eye action-icon" v-b-tooltip.hover title="Follow"
                    v-if="!!customer.follow_status.following === false" @click="
                      followReq(customer),
                        (customer.follow_status.following = true)
                    " />
                  <i class="fas fa-eye-slash action-icon" v-b-tooltip.hover title="Unfollow" v-else @click="
                      UnFollowReq(customer),
                        (customer.follow_status.following = false)
                    " />
                  <i v-if="isMarkedAsSpam(customer)" class="fas fa-info-circle action-icon" v-b-tooltip.hover
                    title="Unblock" @click="removeFromSpamList(customer)" />
                  <i v-else-if="!isMemberMarkedMeAsSpam(customer)" class="fas fa-envelope action-icon" v-b-tooltip.hover
                    title="Message" @click="sendMsg(customer.user)" />
                </div>
            </div>
          </div>
        </b-collapse>
      </div>
      <div class="people-section" v-else>
        <p class="section-title">PEOPLE</p>
        <div>
          <p class="not-found">No matches found</p>
        </div>
      </div>

      <div class="companies-section" v-if="searchResults.companies.length">
        <b-navbar-toggle target="company-results">
          <template #default="{ expanded }">
              <div></div>
              <p class="section-title">COMPANIES ({{searchResults.companies.length}})</p>
              <i v-if="expanded" class="fas fa-angle-up"></i>
              <i v-else class="fas fa-angle-down"></i>
            </template>
        </b-navbar-toggle>
        <b-collapse id="company-results" is-nav>
          <div class="companies">
            <div class="member-box" v-for="company in searchResults.companies" :key="company.id">
              <img :src="
                  company.logo ||
                  require('@/assets/default-company.jpg')
                " alt="" />
              <div class="userInfo">
                <span class="userName" @click="openCompanyProfile(company)">
                  {{company.name }}
                </span>
                <span class="userPosition">{{ company.company_type}}</span>
              </div>
            </div>
          </div>
      </b-collapse>
      </div>
      <div class="companies-section" v-else>
        <p class="section-title">COMPANIES</p>
        <div>
          <p class="not-found">No matches found</p>
        </div>
      </div>
      <div class="events-section" v-if="searchResults.events.length">
        <b-navbar-toggle target="event-results">
          <template #default="{ expanded }">
              <div></div>
              <p class="section-title">EVENTS ({{searchResults.events.length}})</p>
              <i v-if="expanded" class="fas fa-angle-up"></i>
              <i v-else class="fas fa-angle-down"></i>
            </template>
        </b-navbar-toggle>
        <b-collapse id="event-results" is-nav>
          <div class="events" v-for="event in searchResults.events" :key="event.id">
            <b-container class="bv-example-row">
              <div class="for-mobile-design">
                <div class="event-name" @click="openEvent(event)">
                  {{ event.name }}
                </div>
                <b-img :src="event.banner || event.main_banner"></b-img>
                <div class="event-info">
                  <b>
                    {{$formatDate.getUTCDate(event.start_date)}}
                    {{ $formatDate.getUTCMonth(event.start_date) }} -
                    {{$formatDate.getUTCDate(event.end_date)}}
                    {{ $formatDate.getUTCMonth(event.end_date) }}
                    {{$formatDate.getUTCYear(event.start_date)}}
                  </b>
                  <div class="event-city">{{ event.city }}</div>
                </div>
              </div>
            </b-container>
          </div>
        </b-collapse>
      </div>
      <div class="events-section" v-else>
        <p class="section-title">EVENTS</p>
        <div>
          <p class="not-found">No matches found</p>
        </div>
      </div>
      <div class="posts-section" v-if="searchResults.posts.length">
        <b-navbar-toggle target="post-results">
          <template #default="{ expanded }">
              <div></div>
              <p class="section-title">POSTS ({{searchResults.posts.length}})</p>
              <i v-if="expanded" class="fas fa-angle-up"></i>
              <i v-else class="fas fa-angle-down"></i>
            </template>
        </b-navbar-toggle>
        <b-collapse id="post-results" is-nav>
          <div v-for="post in searchResults.posts" :key="post.url" :id="post.shared_post_id || post.id"
            @click="openPost(post)" class="posts">
            <post v-if="!post.is_shared" :postData="post.post_details" :companyDetails="post.company_details"
              :isUserPost="false" :fromSearch="true" />
            <shared-post v-else :postProps="post" :companyDetails="post.company_details" :isUserPost="false"
              :fromSearch="true" />
          </div>
        </b-collapse>
      </div>
      <div class="posts-section" v-else>
        <p class="section-title">POSTS</p>
        <div>
          <p class="not-found">No matches found</p>
        </div>
      </div>
    </div>
    <b-modal v-model="congratulationModalShow" size="md" hide-footer @click="
        congratulationModalShow = false;
        networkModalText = '';
      ">
      <h3 style="text-align: center">CONGRATULATIONS!</h3>
      <p style="text-align: center">{{ networkModalText }}</p>
      <div class="congratulationModal">
        <router-link :to="{ name: 'network' }">My Network</router-link>
        <button @click="
            congratulationModalShow = false;
            networkModalText = '';
          ">
          Continue
        </button>
      </div>
    </b-modal>
  </div>
</template>

<script>
import moment from 'moment';
import { mapGetters, mapActions } from 'vuex';
import getIDfromURL from '../../utils/getIDfromURL';
import Post from '../newsFeed/Post.vue';
import SharedPost from '../newsFeed/SharedPost.vue';
import memberFunctions from '../../utils/mixins/memberFunctions';
import createHistoryDb from '../../utils/searchHistory/createHistoryDb';
import getHistory from '../../utils/searchHistory/getHistory';
import clearHistory from '../../utils/searchHistory/clearHistory';
import updateHistory from '../../utils/searchHistory/updateHistory';

export default {
  components: { Post, SharedPost },
  mixins: [memberFunctions],
  data() {
    return {
      query: '',
      congratulationModalShow: false,
      networkModalText: '',
      showHistory: false,
      searchHistory: {
        queries: [],
        customers: [],
        companies: [],
        posts: [],
        events: [],
      },
    };
  },
  async mounted() {
    const { query } = this.$route.query;
    if (query) {
      this.query = query;
      await this.search();
    }
    // show all collapesed sections
    if (!this.isMobileScreen) {
      document.querySelectorAll('.navbar-toggler').forEach((el) => {
        el.click();
      });
    }
  },
  computed: {
    ...mapGetters({
      searchResults: 'core/searchResults',
      userInfo: 'user/fetchUserInfo',
      isMobileScreen: 'isMobileScreen',
    }),
  },
  watch: {
    $route(to, from) {
      if (to.query.query) {
        this.query = to.query.query;
        this.search();
      }
    },
  },
  methods: {
    ...mapActions({
      getCoreSearch: 'core/getCoreSearch',
    }),
    async openHistory() {
      this.showHistory = true;
      createHistoryDb(this.userInfo.id);
      this.searchHistory = await getHistory(this.userInfo.id);
    },
    openProfile(customer) {
      const { id } = this.userInfo;
      updateHistory(id, {
        customers: {
          name: ` ${customer.user.first_name} ${customer.user.last_name}`,
          customer_id: customer.id,
          company_name: customer.company_name,
          profile_picture: customer.profile_picture,
          job_title: customer.job_title,
        },
      });
      this.searchHistory = { ...this.searchHistory };
      this.goToProfile(customer.id);
    },
    openCompanyProfile(company) {
      const { id } = this.userInfo;
      updateHistory(id, {
        companies: {
          name: company.name,
          company_id: company.id,
          company_type: company.company_type,
          logo: company.logo,
        },
      });
      this.searchHistory = { ...this.searchHistory };
      this.goToCompanyProfile(company.id);
    },
    openEvent(event) {
      const { id } = this.userInfo;
      updateHistory(id, {
        events: {
          name: event.name,
          banner: event.banner || event.main_banner,
          event_id: event.id,
        },
      });
      this.goEventPage(event);
    },
    openPost(post) {
      const { id } = this.userInfo;
      updateHistory(id, {
        posts: {
          content: post.content,
          post_id: post.shared_post_id || post.post_details.id,
          is_shared: post.is_shared,
        },
      });
      this.goToPost(post);
    },
    clear() {
      clearHistory(this.userInfo.id);
      this.searchHistory = {
        queries: [],
        customers: [],
        companies: [],
        posts: [],
        events: [],
      };
    },
    async search(e) {
      const value = e && e.target.value ? e.target.value : this.query;
      this.$router.replace({ name: 'GlobalSearch', query: { query: value } });
      const { id } = this.userInfo;
      updateHistory(id, { queries: { label: value } });
      await this.getCoreSearch(value);
    },
    async searchRecent(query) {
      this.query = query;
      await this.search();
    },
    goEventPage(event) {
      if (event.url.includes('events')) {
        this.$router.push({
          name: 'standardEvent',
          params: { eventId: event.id },
        });
      } else {
        this.$router.push({
          name: 'globalAwardsEvents',
          params: { awardId: event.id, slug: event.slug },
        });
      }
    },
    getID(companyUrl) {
      this.goToCompanyProfile(getIDfromURL(companyUrl));
    },
    goToCompanyProfile(id) {
      if (id) {
        const companyId = `${id}`;
        this.$router.push({ name: 'companyProfile', params: { companyId } });
      }
    },
    moment(date) {
      return moment(new Date(date).toUTCString());
    },
    goToPost(post) {
      if (post.is_shared) {
        this.$router.push({
          name: 'SharedPost',
          params: { id: post.post_id || post.shared_post_id },
        });
      } else {
        this.$router.push({
          name: 'MemberPost',
          params: { id: post.post_id || post.post_details.id },
        });
      }
    },
    eventDays(start, end) {
      let day = this.moment(start).format('DD');
      if (end && start !== end) {
        day = `${this.moment(start).format('DD')} - ${this.moment(end).format('DD')}`;
      }
      return day;
    },
  },
};
</script>

<style scoped src="./search.css"></style>
